import axios from "@/libs/api.request";
// 获取列表
export const getStorageFee = params => {
  return axios.request({
    url: "/finance/StorageFee",
    method: "get",
    params
  });
};

export const create_bill = data => {
  return axios.request({
    url: "/finance/StorageFee/bill",
    method: "post",
    data
  });
};



export const exportExc = params => {
  return axios.request({
    url: "/finance/StorageFee/export",
    method: "get",
    params
  });
};